module.exports = __webpack_public_path__ + "static/media/postgres.dfce6c11.png";